import { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Snackbar,
  Box
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { BirthDateInputForm } from './BirthDateInput/BirthDateInputForm'

type Props = {
  open: boolean
  onClose: () => void
}

export const BirthDateInputDialog: React.FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslation()
  const [snackbar_msg, setSnackbarMsg] = useState('')
  const [submit_state, setSubmitState] = useState<'can' | 'disabled' | 'submitting'>('disabled')

  const handleSuccess = () => {
    onClose()
    setSnackbarMsg(t('sensitive.birth_date_updated'))
  }

  const handleError = (error: string) => {
    setSnackbarMsg(error)
  }

  return <>
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogContent>
        <DialogContentText sx={{ whiteSpace: 'pre-wrap', mb: 4 }}>
          {t('sensitive.birth_date_dialog_description')}
        </DialogContentText>

        <BirthDateInputForm
          onSuccess={handleSuccess}
          onError={handleError}
          onSubmitStateChange={setSubmitState}
        />
      </DialogContent>

      <DialogActions>
        <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-around' }}>
          <Button
            color='inherit'
            fullWidth
            onClick={onClose}
            disabled={submit_state === 'submitting'}
          >
            {t('general.cancel')}
          </Button>
          <Button
            form='birth-date-form'
            type='submit'
            fullWidth
            color='primary'
            disabled={submit_state !== 'can'}
          >
            {t('sensitive.birth_date_save')}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>

    <Snackbar
      open={!!snackbar_msg}
      autoHideDuration={3000}
      onClose={() => setSnackbarMsg('')}
      message={snackbar_msg}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    />
  </>
}
